<template>
  <div class="visitor_config_container section-main__page page-padding">
    <ioc-tab-group ref="tabs"
                   :option="tabOption"
                   @change="handleChange"></ioc-tab-group>
    <div class="section-main__content">
      <div class="public_container"
           v-if="configType.typeId == '1'">
        <div class="radio_box">
          <el-radio-group v-model="publicInOrOut"
                          @change="publicRadioChange">
            <el-radio :label="200000001">厂外访客预约</el-radio>
            <el-radio :label="200000002">厂内访客预约</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="cloud_cotainer"
           v-else>
        <div class="radio_box">
          <el-radio-group v-model="cloudInOrOut"
                          @change="cloudRadioChange">
            <el-radio :label="200000003">厂外访客预约</el-radio>
            <el-radio :label="200000004">厂内访客预约</el-radio>
          </el-radio-group>
        </div>
      </div>
      <el-scrollbar style="height:600px;">
        <div class="form_box">
          <el-form ref="form"
                   :model="publicForm"
                   label-width="270px">
            <el-row>
              <el-col :span="12"
                      v-for="(item, index) in filedList"
                      :key="index">
                <el-form-item :label="labelFormatter[item.fieldName]+'：'"
                              v-if="item.partnerShow&& item.fieldName!='partnerCount'">
                  <el-checkbox v-model="item.displayChecked"
                               @change="checked=>displayChange(checked,item,index)">是否显示</el-checkbox>
                  <el-checkbox v-model="item.requireChecked"
                               @change="checked=>requireChange(checked,item,index)">是否必填</el-checkbox>
                </el-form-item>
                <!--随行人员数量-->
                <el-form-item :label="labelFormatter[item.fieldName]+'：'"
                              v-if="item.fieldName=='partnerCount'">
                  <!-- <el-checkbox v-model="item.displayChecked"
                               @change="checked=>displayChange(checked,item,index)">数值</el-checkbox>
                   <el-checkbox v-model="item.displayChecked"
                               @change="checked=>displayChange(checked,item,index)">对象</el-checkbox> -->
                  <el-select @change="changeSelect(item,index)"
                             value-key="value"
                             v-model="partner.partnerCountValue"
                             label-width="80px"
                             style="width:180px;margin-right: 10px;">
                    <el-option v-for="i in options"
                               :key="i.value"
                               :label="i.label"
                               :value="i"></el-option>

                  </el-select>
                  <el-checkbox v-model="item.requireChecked"
                               @change="checked=>requireChange(checked,item,index)">是否必填</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="btn-container">
        <el-button type="primary"
                   v-auth="'/visitorConfig:config'"
                   @click="onSave">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '../api'
import utils from '@src/common/utils'
import { Dic, Cache, Bus, Base, Dates } from '$utils'
export default {
  components: {},
  data () {
    return {
      partnerCountValue: '',
      partnerShow: true,
      options: [
        {
          value: 0,
          label: '仅输入人数',
          type: '3'
        },
        {
          value: 1,
          label: '配置随行人员详细信息',
          type: '13'
        },
      ],
      tabOption: {
        column: [
          {
            label: "微信公众号",
            prop: "publicAccount",
            typeId: "1",

          },
          {
            label: "鲁南云",
            prop: "cloud",
            typeId: "2",
          },
        ],
      },
      configType: {},
      publicInOrOut: 200000001,
      cloudInOrOut: 200000003,
      publicForm: {
        type: [],
        filedList: [
          {
            "fieldName": "fileCode",
            "display": "1",
            "required": "1",
            displayChecked: true,
            requireChecked: true
          },
          {
            "fieldName": "name",
            "display": "1",
            "required": "0",
            displayChecked: true,
            requireChecked: false
          }
        ],
      },
      partner: {
        partnerCountValue: '',
        type: ''
      },

      cloudForm: {},
      filedList: [
        {
          "fieldName": "fileCode",
          "display": "1",
          "required": "1"
        },
        {
          "fieldName": "name",
          "display": "1",
          "required": "0"
        }
      ],
      labelFormatter: {
        fileCode: '图片',
        name: '姓名',
        sex: '性别',
        phone: '电话',
        idCard: '身份证号',
        company: '单位',
        healthCodeStatus: '健康码是否为绿码',
        riskAreaStatus: '14天是否到过中高风险区域',
        riskLevel: '所属风险等级',
        promiseStatus: '个人是否签订《疫情防控承诺书》',
        partnerCount: '随行人员数量',
        partnerUrl: '随行人员图片',
        partnerName: '随行人员姓名',
        partnerSex: '随行人员性别',
        partnerPhone: '随行人员电话',
        partnerIdCard: '随行人员身份证号',
        partnerCompany: '随行人员单位',
        partnerHealthCodeStatus: '随行人员健康码是否为绿码',
        partnerRiskAreaStatus: '随行人员14天是否到过中高风险区域',
        partnerRiskLevel: '随行人员所属风险等级',
        partnerPromiseStatus: '随行人员是否签订《疫情防控承诺书》'
      },
      // 模板Code
      templateCode: 200000001,
      type: ''
    }
  },
  created () {
    // 默认进入页面选中第一种分类方式
    this.configType = this.tabOption.column[0];
  },
  mounted () {
    // this.filedList.map((item) => {
    //   item.display == 1 ? this.$set(item, 'displayChecked', true) : this.$set(item, 'displayChecked', false)
    //   item.required == 1 ? this.$set(item, 'requireChecked', true) : this.$set(item, 'requireChecked', false)
    //   return item
    // })
    this.getFiled(200000001);
  },
  methods: {
    changeSelect (item, index) {
      // this.partner.partnerCountValue=val.label;
      item.type = this.partner.partnerCountValue.type;
      //如果选择仅输入人数，隐藏随行人员信息
      if (item.type == '3') {
        let filedListArr = this.filedList.slice(11);
        filedListArr.forEach(res => {
          res.partnerShow = false;
        })
      } else {
        this.filedList.forEach(res => {
          res.partnerShow = true;
        })
      }
      //如果选择仅输入人数，隐藏随行人员信息
      if (item.type == '3') {
        let filedListArr = this.filedList.slice(11);
        filedListArr.forEach(res => {
          res.partnerShow = false;
        })
      } else {
        this.filedList.forEach(res => {
          res.partnerShow = true;
        })
      }
      // console.log(val, '====val')
      console.log(this.partner);
      //如果选择仅输入人数，隐藏随行人员信息
      if (item.type == '3') {
        let filedListArr = this.filedList.slice(11);
        filedListArr.forEach(res => {
          res.partnerShow = false;
        })
      } else {
        this.filedList.forEach(res => {
          res.partnerShow = true;
        })
      }
    },
    // 切换选项卡
    handleChange (column) {
      this.configType = column;
      if (this.configType.typeId === "1") {
        this.publicInOrOut = 200000001;
        this.getFiled(200000001);
      } else {
        this.cloudInOrOut = 200000003;
        this.getFiled(200000003)
      }
    },
    publicRadioChange (val) {
      this.templateCode = val
      this.getFiled(this.templateCode);
    },
    cloudRadioChange (val) {
      this.templateCode = val;
      this.getFiled(this.templateCode)
    },
    displayChange (checked, data, index) {
      this.filedList[index].displayChecked = checked;
      if (!checked) {
        this.filedList[index].requireChecked = false;
        this.filedList[index].required = '0';
      }
      this.filedList[index].display = checked ? '1' : '0'
    },
    requireChange (checked, data, index) {
      this.filedList[index].requireChecked = checked;
      this.filedList[index].required = checked ? '1' : '0';
      if (checked) {
        this.filedList[index].displayChecked = true;
        this.filedList[index].display = '1'
      }
      // this.filedList[index].displayChecked = checked;
    },
    // 获取模板字段
    getFiled (code) {
      let params = {
        templateCode: code
      }
      this.$fetch(api.config.getTemplateField, params).then((res) => {
        if (res.success) {
          this.filedList = res.returnObj;
          this.filedList.map((item) => {
            item.partnerShow = true;
            if (item.fieldName == 'partnerCount') {
              this.type = item.type;
              item.type == '3' ? this.partner.partnerCountValue = this.options[0].label : this.partner.partnerCountValue = this.options[1].label;
              item.required == 1 ? this.$set(item, 'requireChecked', true) : this.$set(item, 'requireChecked', false)
              return item
            } else {
              item.display == 1 ? this.$set(item, 'displayChecked', true) : this.$set(item, 'displayChecked', false)
              item.required == 1 ? this.$set(item, 'requireChecked', true) : this.$set(item, 'requireChecked', false)
              return item
            }
          })
          //返回随行人员的type为3隐藏随行人员的数据
          if (this.type == '3') {
            let filedListArr = this.filedList.slice(11);
            filedListArr.forEach(res => {
              res.partnerShow = false;
            })
            //this.filedList=filedListArr;
          } else {
            this.filedList.forEach(res => {
              res.partnerShow = true;
            })
          }
          console.log('---this9999', this.filedList);
        } else {
          this.$message.error(res.msgContent)
        }

      })
    },
    onSave () {
      this.filedList.map((item) => {
        delete item.displayChecked;
        delete item.requireChecked;
        return item
      })
      // if (this.cloudInOrOut == 200000003) {
      //   this.templateCode = '200000003'
      //   console.log(this.templateCode, '====this.templateCode========200003')
      // } else if (this.cloudInOrOut == 200000004) {
      //   this.templateCode = '200000004'
      //   console.log(this.templateCode, '====this.templateCode')
      // } else if (this.publicInOrOut == 200000001) {
      //   this.templateCode = '200000001'
      // } else {
      //   this.templateCode = '200000002'
      // }
      let params = {
        appointmentTemplateFieldList: this.filedList,
        templateCode: this.templateCode
      }
      this.$fetch(api.config.updateTemplateField, params).then((res) => {
        if (res.success) {
          this.$message.success('保存成功');
          this.getFiled(this.templateCode)
        } else {
          this.$message.error(res.msgContent)
        }

      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.visitor_config_container {
  width: 100%;
  height: 100%;
  .section-main__content {
    width: 100%;
    .public_container,
    .cloud_cotainer {
      width: 100%;
      .radio_box {
        height: 38px;
        line-height: 38px;
      }
    }
    .btn-container {
      width: 100%;
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>